import type { FormsEnumsRecurrenceTypeEnum } from 'generated/resources/datatable.graphql'
import type { FormsScheduleRecurrenceTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
export const mapRecurrenceTypeFromBackend = (
  recurrenceType: FormsEnumsRecurrenceTypeEnum | 'onetime' | null | undefined
): FormsScheduleRecurrenceTypeEnum => {
  switch (recurrenceType) {
    case 'daily':
    case 'weekly':
    case 'monthly':
    case 'quarterly':
    case 'yearly':
      return recurrenceType
    default:
      return 'onetime'
  }
}

export function formRecurrenceMapper(status: FormsScheduleRecurrenceTypeEnum) {
  switch (status) {
    case 'onetime':
      return i18n.t('forms.schedule.recurrence_options.onetime')
    case 'daily':
      return i18n.t('forms.schedule.recurrence_options.daily')
    case 'weekly':
      return i18n.t('forms.schedule.recurrence_options.weekly')
    case 'monthly':
      return i18n.t('forms.schedule.recurrence_options.monthly')
    case 'quarterly':
      return i18n.t('forms.schedule.recurrence_options.quarterly')
    case 'yearly':
      return i18n.t('forms.schedule.recurrence_options.yearly')
    default:
      return status satisfies never
  }
}
